import PropTypes from 'prop-types';
import { jsx } from 'react/jsx-runtime';

const TimelineTitle = _ref => {
  let {
    as: Tag,
    children,
    className,
    ...rest
  } = _ref;
  return /*#__PURE__*/jsx(Tag, {
    className: className,
    ...rest,
    children: children
  });
};
TimelineTitle.defaultProps = {
  className: '',
  children: null,
  as: 'h4'
};
TimelineTitle.propTypes = {
  className: PropTypes.string,
  as: PropTypes.node,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export { TimelineTitle };
//# sourceMappingURL=TimelineTitle.js.map
